import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  background: #DEDEDE;
  border-bottom: 2px solid #fff;
  height: 70px;
  &.fixed {
    position: fixed;
    top: 76px;
    left: 0;
    right: 0;
    z-index: 4;
    overflow: hidden;
  }
  .flex {
    justify-content: space-evenly;
  }
  a {
    border: 0;
    background: none;
    border-left: 2px solid #fff;
    display: flex;
    height: 100%;
    width: 100%;
    padding: 0 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
    font: 600 16px Montserrat;
    color: #40403F;
    text-decoration: none;
    border-bottom: 4px solid transparent;
    white-space: nowrap;
    transition: all 0.3s;
    &:last-child {
      border-right: 2px solid #fff;
    }
    @media (min-width: 540px) {
      &:hover {
        background: #fff;
      }
    }
  }
  @media (max-width: 789px) {
    display: none;
  }
`

class Bar extends Component {
  state = {
    fixed: false,
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = (event) => {
    if ((document.body.clientWidth > 789 && window.scrollY > 182)) {
      this.setState({fixed: true});
      document.querySelector("body").classList.add('bar-fixed')
    } else {
      this.setState({fixed: false});
      document.querySelector("body").classList.remove('bar-fixed')
    }
  };

  render () {
    const { tabs } = this.props;
    return (
      <Container id="bar-a-guararapes" className={ this.state.fixed ? 'fixed' : '' }>
        <div className="wrapper flex">
          {
            tabs && tabs.map((item, index) => {
              return (
                <Link to={ `/a-guararapes/${item.link}` } key={ index }>
                  <span>
                    { item.nome }
                  </span>
                </Link>
              )
            })
          }
        </div>
      </Container>
    )
  }
}

Bar.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default Bar;
